import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { injectMutation } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';

import { UserService as ApiUserService } from '@/api/services/user.service';
import { UserService } from '@/core/services/user.service';
import { EducaDialogRef } from '@/shared/components/dialog';
import { ModalContentComponent } from '@/shared/components/modal-content/modal-content.component';

@Component({
  selector: 'app-edit-teacher-availability-confirmation',
  imports: [ModalContentComponent, ReactiveFormsModule],
  templateUrl: './edit-teacher-availability-confirmation.component.html',
  styleUrl: './edit-teacher-availability-confirmation.component.scss'
})
export class EditTeacherAvailabilityConfirmationComponent {
  private userService = inject(UserService);
  readonly currentUser = this.userService.getUserData();
  private apiUserService = inject(ApiUserService);
  dialogRef = inject(EducaDialogRef);

  availabilityMutation = injectMutation(() => ({
    mutationFn: async (event: Event) => {
      event?.preventDefault();
      const currentUser = this.userService.getUserData();
      await lastValueFrom(
        this.apiUserService.apiUserItemIdAvailabilityPut({
          item_id: currentUser.id!,
          body: {
            is_available: true
          }
        })
      );
    },
    onSuccess: () => {
      this.dialogRef.close(true);
      this.userService.setIsAvailable(true);
    }
  }));
}
